(function pipe(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousPipe = global.NewHomeSource.Pipe;

  /**
  * @private
  *
  * composeFunctions: executes a set of functions in the given order whilst they return true.
  * @param {object} functions is the array of functions needed to execute.
  */
  function composeFunctions(functions) {
    return function composeFuncs() {
      const parameters = arguments;
      const length = functions.length;
      let result = true;
      let functionIndex = 0;

      while (result && functionIndex < length) {
        result = typeof functions[functionIndex] === 'function' && functions[functionIndex].apply(this, parameters);
        functionIndex += 1;
      }

      return result;
    };
  }

  /**
  * @constructs NewHomeSource.Pipe
  */
  function Pipe() {
  }

  /**
  * @public
  *
  * conditionalPipe: calls the private composeFunctions with the functions array needed to execute.
  */
  Pipe.conditionalPipe = function conditionalPipe() {
    return composeFunctions(arguments);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Pipe to the previous script.
   */
  Pipe.noConflict = function noConflict() {
    global.NewHomeSource.Pipe = previousPipe;
    return Pipe;
  };

  global.NewHomeSource.Pipe = Pipe;
}(window));
